/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";

export class InvoiceDateChangeRequestVoModel extends JSONable {

  createdBy: string | null = null;

  createdAt: string | null = null;

  newInvoiceStartDate: string | null = null;

  attachmentUuids: string[] | null = null;

  comment: string | null = null;

}
